// extracted by mini-css-extract-plugin
export default {"productGrid":"x4-z","centerLink":"y4-z","productSection":"z4-z","item":"A4-z","ctaButton":"B4-z"};